<template>
  <v-dialog v-model="dialog" max-width="600px">
    <v-card v-if="notification">
      <v-card-title class="primaryDialogTitle">
        <span class="headline">Notification Detail</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pa-4">
        <v-row>
          <v-col cols="12">
            <div class="mb-4">
              <div class="caption grey--text">Send Date</div>
              <div class="body-1">
                {{ notification.created_at | moment('DD-MMM-YYYY HH:mm:ss') }}
              </div>
            </div>
          </v-col>

          <v-col cols="12" v-if="notification.profile || notification.user">
            <div class="mb-4">
              <div class="caption grey--text">Recipient</div>
              <div class="body-1">
                {{ getRecipient().name | parseAndLocalize('en') }} {{ getRecipient().phone }}
              </div>
            </div>
          </v-col>

          <v-col cols="12">
            <div class="mb-4">
              <div class="caption grey--text">Content</div>
              <div class="body-1">{{ parseContent(notification.content) }}</div>
            </div>
          </v-col>

          <v-col cols="12">
            <div class="mb-4">
              <div class="caption grey--text">Created At</div>
              <div class="body-1">
                {{ notification.created_at | moment('DD-MMM-YYYY HH:mm:ss') }}
              </div>
            </div>
          </v-col>

          <v-col cols="12">
            <div class="mb-4">
              <div class="caption grey--text">Read Status</div>
              <v-chip v-if="notification.read" small label color="success"
                >Read at {{ notification.read | moment('YYYY-MM-DD HH:mm') }}</v-chip
              >
              <v-chip v-else small label color="warning">Unread</v-chip>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          v-if="!notification.read"
          color="success"
          :loading="markingAsRead"
          @click="markAsRead"
        >
          Mark as Read
        </v-btn>
        <v-btn color="primary" text @click="dialog = false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from '@/api';
import { mapActions } from 'vuex';

export default {
  name: 'NotificationDetailDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    notification: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      markingAsRead: false,
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    ...mapActions('alert', ['updateAlertMessage']),

    async markAsRead() {
      if (!this.notification || !this.notification._id) return;

      try {
        this.markingAsRead = true;
        await api.patch(`rml/me/Notifications/${this.notification._id}/read`);

        await this.updateAlertMessage({
          msg: 'Notification marked as read',
          type: 'success',
          color: 'success',
        });

        this.$emit('read', this.notification._id);
        this.dialog = false;
      } catch (error) {
        console.error('Error marking notification as read:', error);
        await this.updateAlertMessage({
          msg: 'Failed to mark notification as read',
          type: 'error',
        });
      } finally {
        this.markingAsRead = false;
      }
    },

    getRecipient() {
      if (this.notification.profile) {
        return {
          name: this.notification.profile.name,
          phone: this.notification.profile.phone,
        };
      } else if (this.notification.user) {
        return {
          name: this.notification.user.name,
          phone: this.notification.user.phone,
        };
      }
      return {
        name: '-',
        phone: '-',
      };
    },
    parseContent(content) {
      if (!content) return '';

      try {
        const parsed = JSON.parse(content);
        return parsed.en || parsed['zh-hk'] || content;
      } catch {
        return content;
      }
    },
    formatType(type) {
      if (!type) return 'Unknown';

      return type
        .replace(/_/g, ' ')
        .replace(/:/g, ' ')
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    },
  },
};
</script>

<style scoped>
.headline {
  font-size: 1.25rem;
  font-weight: 500;
}
</style>
